import { academyNameOf, useAdminView } from "./useAdminView";
import "./AdminViewPicker.css";

// 운영진 보기 중일 때만 맨 위에 뜨는 줄. 어느 학원을 보고 있는지와 '돌아가기'.
// 학원 고르기는 오른쪽 위 계정 메뉴에 있다(UserMenu).
const AdminViewPicker = () => {
  const { user, isViewing, goBack } = useAdminView();
  if (!isViewing) return null;

  return (
    <div className="admin-view">
      <div className="admin-view__inner">
        <span className="admin-view__label">
          <b>{academyNameOf(user)}</b> 화면을 보는 중 · 보기 전용
        </span>
        <button type="button" className="admin-view__back" onClick={goBack}>
          운영진 계정으로 돌아가기
        </button>
      </div>
    </div>
  );
};

export default AdminViewPicker;
